import { JobBoardsSearchHistoryComponent } from "./job-boards-search-history.component";
export var JobBoardsSearchHistoryModule = angular
    .module('jobBoardsSearchHistory', [])
    .component(JobBoardsSearchHistoryComponent.selector, JobBoardsSearchHistoryComponent.component)
    .name;
//# sourceMappingURL=job-boards-search-history.module.js.map